import { render, staticRenderFns } from "./ContractFold.vue?vue&type=template&id=7a512c03&scoped=true"
import script from "./ContractFold.vue?vue&type=script&lang=js"
export * from "./ContractFold.vue?vue&type=script&lang=js"
import style0 from "./ContractFold.vue?vue&type=style&index=0&id=7a512c03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a512c03",
  null
  
)

export default component.exports